import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { clock, dropDown, eventArrow, eventIcon, noEvent } from "../../asset";
// import { eventsData } from "../../util/Constants";
import { CustomArrowProps } from "react-slick";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { Link } from "react-router-dom";

function CustomArrow({
  onClick,
  isLast,
  goToStart,
}: CustomArrowProps & {
  isLast?: boolean;
  goToStart?: () => void;
}) {
  const handleClick = () => {
    if (isLast && goToStart) {
      goToStart();
    } else {
      onClick?.();
    }
  };

  return (
    <div className="flex justify-end items-end">
      <button
        onClick={handleClick}
        className="bg-primary-50 rounded-l-[4px] py-2 px-3"
      >
        <img
          src={eventArrow}
          alt="move"
          className={`transition-transform duration-300 ${
            isLast ? "rotate-180" : ""
          }`}
        />
      </button>
    </div>
  );
}

export default function EventsCard() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const upcomingEvent = useSelector(
    (state: RootState) => state.dashboard.data?.upcomingEvent,
  );

  // Normalize to array (future-proof)
  const eventsData = upcomingEvent
    ? Array.isArray(upcomingEvent)
      ? upcomingEvent
      : [upcomingEvent]
    : [];

  const isLastSlide =
    eventsData.length > 0 && currentSlide === eventsData.length - 1;

  const sliderRef = useRef<Slider | null>(null);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,

    afterChange: (index: number) => setCurrentSlide(index),

    nextArrow: (
      <CustomArrow
        isLast={isLastSlide}
        goToStart={() => sliderRef.current?.slickGoTo(0)}
      />
    ),

    prevArrow: <></>,

    appendDots: (dots) => (
      <div className="pt-4 pb-2">
        <ul className="flex justify-center">{dots}</ul>
      </div>
    ),

    customPaging: () => <div className="w-2 h-2 rounded-full bg-neutral-100" />,
  };

  return (
    <div className="bg-white rounded-l-2xl shadow-[0_0_54px_0_rgba(0,0,0,0.05)] pt-4 pb-2 pl-4">
      {/* Header */}
      <div className="flex justify-between items-center gap-4">
        <div className="flex gap-3 items-center">
          <img src={eventIcon} alt="Upcoming Events" />
          <p className="text-base text-neutral-500 font-medium text-nowrap">
            Upcoming Events
          </p>
        </div>
        <Link to="/calendar-and-events">
          <img
            src={dropDown}
            alt="dropdown"
            className="w-[18px] h-[18px] -rotate-90 mr-[18px]"
          />
        </Link>
      </div>

      {/* Empty State */}
      {eventsData.length === 0 ? (
        <div className="flex flex-col gap-4 pt-5 pb-2 justify-center items-center">
          <img
            src={noEvent}
            alt="no event"
            className="w-10 h-10 border-2 rounded-full p-2 border-neutral-200"
          />
          <p className="text-neutral-300 text-base font-medium text-center underline">
            No upcoming events
          </p>
        </div>
      ) : (
        <div className="pt-5">
          <Slider ref={sliderRef} {...settings}>
            {eventsData.map((item, i) => {
              const formattedDate = new Date(
                `${item.startDate}T${item.startTime || "00:00:00"}`,
              ).toLocaleDateString("default", {
                month: "short",
                day: "2-digit",
                year: "numeric",
              });

              const formattedTime = new Date(
                `${item.startDate}T${item.startTime || "00:00:00"}`,
              ).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              });

              return (
                <div key={item.eventId || i}>
                  <div className="flex flex-col gap-[10px] pr-7">
                    {/* Date & Time */}
                    <div className="flex justify-between items-center">
                      <div className="flex gap-2 items-center">
                        <img
                          src={clock}
                          alt="icon"
                          className="w-[14px] h-[14px]"
                        />
                        <p className="text-xs text-neutral-400">
                          {formattedDate}
                        </p>
                      </div>

                      <div className="flex gap-2 items-center">
                        <img
                          src={clock}
                          alt="icon"
                          className="w-[14px] h-[14px]"
                        />
                        <p className="text-xs text-neutral-400">
                          {formattedTime}
                        </p>
                      </div>
                    </div>

                    {/* Event Info */}
                    <div className="flex flex-col items-start gap-[10px]">
                      <p className="text-base text-neutral-400 font-medium">
                        {item.title}
                      </p>

                      <p className="text-sm text-neutral-300 line-clamp-2">
                        {item.description}
                      </p>

                      <Link
                        to="/calendar-and-events"
                        className="text-primary-500 underline text-[13px] font-medium"
                      >
                        View Full Event
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      )}
    </div>
  );
}
